/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const slider = () => {
		if(document.querySelectorAll('.news-slider').length) {
			new Swiper('.news-slider', {
				slidesPerView: 1,
				spaceBetween: 0,
				// loop: true,
				// loopAdditionalSlides: 1,
				speed: 1000,
				autoplay: false,
				watchSlidesProgress: true,
				navigation: {
					nextEl: '.news-slider-control .swiper-button-next',
					prevEl: '.news-slider-control .swiper-button-prev',
				},
				breakpoints: {
				  1024: {
					slidesPerView: 3,
					spaceBetween: 40,
				  },
				},
			});
		}
	};

	const tab = () => {
		let $tabs = document.querySelectorAll('.js-news-tab');
		if ($tabs.length) {
			// ハッシュタグで絞り込み
			if (location.search) {
				const category = location.search.replace("?", "");
				let haveCategory = false;
				console.log(category);
				$tabs.forEach(tab => {
					tab.classList.remove(a);
					if (tab.getAttribute('data-target').match(category)) {
						tab.classList.add(a);
						haveCategory = true;
					}
				});
				if(haveCategory === false){
					$tabs[0].classList.add(a);
				}
			}else {
				$tabs[0].classList.add(a);
			}

		}
	}

	const dropDown = () => {
		if(document.querySelector('.js-news-yearList')) {
			// 最新と最古の年を取得
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;
			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');
			const yearListSubmit = document.querySelector('.js-news-yearList-submit');
			// オプションテキスト
			let optionText = '最新';
			if (location.pathname.split('/')[1] === 'global') {
				optionText = 'Latest';
			}
			const optionVal = (_num) => {
				if(location.pathname.match(/\d{4}/)){
					// 文字列に正規表現4桁数値が含まれていたら
					return location.pathname.replace(location.pathname.match(/\d{4}/)[0], _num);
				} else {
					// 文字列に正規表現4桁数値が含まれて無かったら
					return location.pathname.replace('/news/','/news/'+_num+'/');
				}
			};
			// オプションを追加
			let newsVal;
			if(location.pathname.match(/\d{4}/)){
				// 文字列に正規表現4桁数値が含まれていたら
				newsVal = location.pathname.replace(location.pathname.match(/\d{4}/)[0]+'/', '');
			} else {
				// 文字列に正規表現4桁数値が含まれて無かったら
				newsVal = location.pathname;
			}
			yearList.appendChild(new Option(optionText, newsVal));
			// 最新から最古の年までのオプションを生成し追加
			for(var i =latest; i>=earliest; i--) {
				const option = document.createElement('option');
				option.textContent = i.toString();
				option.value = optionVal(i);
				document.querySelector('.js-news-yearList').appendChild(option);
			}
			// ドロップダウンリストで選択された年を設定
			yearList.value = location.pathname;
			// ドロップダウンリストの変更イベントを処理

			yearListSubmit.addEventListener('click', function () {
				location.href = yearList.value;
			});
		}
	};

	slider();
	tab();
	dropDown();


})(window.FUNCTIONS);
